// extracted by mini-css-extract-plugin
module.exports = {"fontFamily":"FontFamilySelectControl_fontFamily__3LklH","fontStyle":"FontFamilySelectControl_fontStyle__1UxJG"};